import { useRef, useState, useCallback } from "react";

const useScrollReveal = (options = {}) => {
  const { delay = 0, ...ioOptions } = options;
  const observerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  const ref = useCallback(
    (node) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }

      if (!node) return;

      if (delay > 0) {
        node.style.transitionDelay = `${delay}ms`;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.08, ...ioOptions }
      );

      observer.observe(node);
      observerRef.current = observer;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [delay]
  );

  return [ref, isVisible];
};

export default useScrollReveal;
